module.exports = __webpack_public_path__ + "media/images/themes/dark/epic-games-light-f82e5e07f52f7bf57abadc86149d2354.svg";